import React, {Component} from 'react';
import styled from 'styled-components';
import {FaPlus, FaTimesCircle} from 'react-icons/fa';
import {Dialog} from '@mui/material'; // Using MUI Dialog for loading
import Get from './components/Get';
import Post from './components/Post';
import color from './components/color';

const option = {
  title: 'Loading',
  message: 'Please Wait..',
};

export default class PostFree extends Component {
  constructor() {
    super();
    this.state = {
      total: 0,
      data: [],
      walletBalance: 0,
      loading: false,
    };
  }

  componentDidMount() {
    this.wallet();
  }

  wallet() {
    Get.Wallet().then(res => {
      if (res.wallet) {
        this.setState({walletBalance: res.wallet.balance});
      }
    });
  }

  add() {
    let array = [...this.state.data];
    let value = this.state.numbers;
    let total = this.state.total;
    if (value && this.state.amounts) {
      if (value.match(/^[0-9]*$/)) {
        if (value.length === 1) {
          total += parseFloat(this.state.amounts);
          array.push({number: value, amount: this.state.amounts, type: 'a'});
        } else if (value.length === 2) {
          total += parseFloat(this.state.amounts);
          array.push({
            number: value === '00' ? '100' : value,
            amount: this.state.amounts,
            type: 'j',
          });
        } else if (value.length === 3) {
          if (value !== '100') {
            total += parseFloat(this.state.amounts);
            array.push({
              number: value[value.length - 1],
              amount: this.state.amounts,
              type: 'b',
            });
          } else {
            array.push({number: 100, amount: this.state.amounts, type: 'j'});
          }
        } else if (value.length % 2 === 0) {
          const data = value.split('');
          for (let i = 1; i < data.length; i += 2) {
            total += parseFloat(this.state.amounts);
            array.push({
              number: data[i - 1] + data[i],
              amount: this.state.amounts,
              type: 'j',
            });
          }
        } else {
          alert('Please enter an even number');
          return;
        }
      } else {
        alert('Please enter only numbers');
        return;
      }
      this.setState({data: array, total});
    } else {
      alert('Please enter number and amount');
    }
  }

  total() {
    let total = 0;
    this.state.data.forEach(item => {
      total += parseFloat(item.amount);
    });
    this.setState({total});
  }

  submit() {
    this.setState({loading: true});
    Post.Bidding(this.state)
      .then(res => {
        this.setState({loading: false});
        if (res.success) {
          alert('Your Jantari Submitted Successfully');
          this.setState({data: [], total: 0});
          this.wallet();
        }
      })
      .catch(err => {
        this.setState({loading: false});
        console.error(err);
      });
  }

  render() {
    return (
      <Container>
        <Dialog open={this.state.loading}>
          <div style={{padding: 20}}>{option.message}</div>
        </Dialog>

        <ScrollArea>
          <BalanceCard>
            <div>
              Available Wallet Balance:{' '}
              <strong>{this.state.walletBalance}</strong>
            </div>
          </BalanceCard>

          <Card>
            {this.state.error && <ErrorText>{this.state.error}</ErrorText>}
            <div>
              <label>Number</label>
              <Input
                type="text"
                value={this.state.numbers || ''}
                onChange={e => this.setState({numbers: e.target.value})}
                placeholder="Number"
              />
            </div>
            <div>
              <label>Amount</label>
              <Input
                type="text"
                value={this.state.amounts || ''}
                onChange={e => this.setState({amounts: e.target.value})}
                placeholder="Amount"
              />
            </div>
            <Button onClick={() => this.add()}>
              <FaPlus /> Add
            </Button>
          </Card>

          <Card>
            <Row>
              <Col>Number Type</Col>
              <Col>Number</Col>
              <Col>Amount</Col>
              <Col></Col>
            </Row>
            {this.state.data.map((item, index) => (
              <Row key={index}>
                <Col>
                  {item.type === 'j'
                    ? 'Jodi'
                    : item.type === 'a'
                    ? 'Andar'
                    : 'Bahar'}
                </Col>
                <Col style={{textAlign: 'center'}}>{item.number}</Col>
                <Col style={{textAlign: 'center'}}>{item.amount}</Col>
                <Col style={{textAlign: 'center'}}>
                  <FaTimesCircle
                    onClick={() => {
                      const newData = [...this.state.data];
                      newData.splice(index, 1);
                      this.setState({data: newData}, () => this.total());
                    }}
                    style={{cursor: 'pointer'}}
                  />
                </Col>
              </Row>
            ))}
            <Row>
              <Col>Total Amount</Col>
              <Col></Col>
              <Col style={{textAlign: 'center'}}>{this.state.total}</Col>
              <Col></Col>
            </Row>
          </Card>
        </ScrollArea>

        {this.state.data.length > 0 && (
          <Button onClick={() => this.submit()} style={{width: '100%'}}>
            Click here to Submit
          </Button>
        )}
      </Container>
    );
  }
}

// Styled Components
const Container = styled.div`
  background-color: #f9f9f9;
  min-height: 100vh;
`;

const ScrollArea = styled.div`
  padding: 20px;
`;

const BalanceCard = styled.div`
  background-color: ${color.primary};
  color: white;
  padding: 10px;
  text-align: center;
`;

const Card = styled.div`
  background: white;
  margin: 10px 0;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

const Input = styled.input`
  width: 100%;
  padding: 8px;
  margin: 6px 0;
  border-radius: 5px;
  border: 1px solid #ccc;
`;

const Button = styled.button`
  background-color: ${color.primary};
  color: white;
  padding: 10px;
  border: none;
  border-radius: 5px;
  margin-top: 10px;
  cursor: pointer;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #ccc;
`;

const Col = styled.div`
  flex: 1;
`;

const ErrorText = styled.div`
  color: red;
  margin-bottom: 10px;
`;
